export function reinitializeFlourishEmbeds(): void {
  if (typeof window === "undefined") {
    return
  }

  const flourishEmbeds = document.querySelectorAll(".flourish-embed")
  if (flourishEmbeds.length === 0) {
    return
  }

  const uninitializedEmbeds = Array.from(flourishEmbeds).filter((embed) => {
    const hasIframe = embed.querySelector("iframe")
    const isLoading = embed.hasAttribute("data-flourish-loading")

    return !hasIframe && !isLoading
  })

  if (uninitializedEmbeds.length === 0) {
    return
  }

  // Stategy A: This is the documented way to load an embed dynamically
  if (window.Flourish?.loadEmbed) {
    for (const embed of uninitializedEmbeds) {
      embed.setAttribute("data-flourish-loading", "true")
      window.Flourish.loadEmbed(embed)
    }
    return
  }

  if (window.FlourishLoaded) {
    // Stategy B: If the library isn't globally available yet, we force a reload
    // We remove the global flag so the script thinks it's running for the first time.

    delete window.FlourishLoaded
  }

  const script = document.querySelector<HTMLScriptElement>(
    'script[src*="flourish"][src$="/embed.js"]',
  )

  if (script?.parentNode && script.src) {
    for (const embed of uninitializedEmbeds) {
      embed.setAttribute("data-flourish-loading", "true")
    }

    const newScript = document.createElement("script")
    newScript.src = script.src
    newScript.async = true
    script.parentNode.removeChild(script)
    document.body.append(newScript)
  }
}
